// extracted by mini-css-extract-plugin
export default {"noContent":"NoContent_noContent__Cfyfr","noContent_icon":"NoContent_noContent_icon__Zz6wu","noContent_text":"NoContent_noContent_text__8AoL8"};